import { render, staticRenderFns } from "./RecordDetailList.vue?vue&type=template&id=07861e2b&scoped=true&"
import script from "./RecordDetailList.vue?vue&type=script&lang=js&"
export * from "./RecordDetailList.vue?vue&type=script&lang=js&"
import style0 from "./RecordDetailList.vue?vue&type=style&index=0&id=07861e2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07861e2b",
  null
  
)

export default component.exports